module.exports = __webpack_public_path__ + "img/darkblue_online.54baeac0.png";